import { axios } from '@/configs'
import type { SignInResponse } from '@/root/shared-types/api/auth'

export type WebEidAuthToken = {
  unverifiedCertificate: string
  algorithm: string
  signature: string
  format: string
  appVersion?: string
}

export type ChallengeResponse = {
  nonce: string
  challengeToken: string
}

export const getChallenge = () =>
  axios.get<ChallengeResponse>('auth/challenge')

export const verifyWebEid = (authToken: WebEidAuthToken, challengeToken: string) =>
  axios.post<SignInResponse>('auth/verify', { authToken, challengeToken })
